import { World } from '@cog/ecs'
import { CanvasContext } from '@cog/ecs-canvas-2d-plugin'


export const world = new World({ context: new CanvasContext(), initialEntityTableSize: 1 })
